import React from 'react';
import ViewWrapper from '../../elements/ViewWrapper';
import './DownloadsView.less';

const DownloadsView: React.FC = () => {
  return (
    <ViewWrapper>
      <div className="downloads-iframe-container">
        <iframe
          src="https://s3.us-east-2.amazonaws.com/readysetupdates/Updates3_0/downloads.html"
          title="ReadySet Downloads"
          className="downloads-iframe"
        />
      </div>
    </ViewWrapper>
  );
};

export default DownloadsView;
